if (window.innerWidth < 1024) {
  const swiperHow = new Swiper(".swiper-how", {
    loop: true,
    autoHeight: true,
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 20,

    // Navigation arrows
    navigation: {
      nextEl: ".swiper-next",
      prevEl: ".swiper-prev",
    },
  });
}
